import { SapOdpCopySource } from 'app/model/pipeline/copysource/sap-odp.copysource';
import { Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { SapCdcDataset } from 'app/model/dataset/sap-cdc.dataset';

/**
 * @deprecated
 */
@Metamodel.model({
    name: adfModelTypeMap.sapCdc.copySourceType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(SapCdcDataset)
        ]
    }
})
export class SapCdcCopySource extends SapOdpCopySource {}
